import { useCallback } from 'react';

import { Checkout as CheckoutComponent } from '@givebacks/shop';
import { useSearchParams } from 'react-router-dom';
import { LoadingOverlay } from 'ui';

import { useInAppShortSessionsLayoutContextLayout } from '../../root/Layouts/InAppShortSessionsLayout';

const Checkout = () => {
  const [searchParams] = useSearchParams();
  const checkoutId = searchParams.get('checkoutId');

  const { closeNativeBrowser } = useInAppShortSessionsLayoutContextLayout();

  const handleSuccess = useCallback(() => {
    closeNativeBrowser('/donate', 200, 'closed');
  }, [closeNativeBrowser]);

  const handleClose = useCallback(() => {
    closeNativeBrowser('/donate', 500, 'donate-cancel');
  }, [closeNativeBrowser]);

  if (!checkoutId) return null;

  return (
    <CheckoutComponent
      containerProps={{
        // Worked with Elliot to get this gradient to look good when the in-app browser is open
        bg: `linear-gradient(175deg, #DDE8FF 0%, #C0D5FF 14%, #4D5D85 52%, #222F57 79.5%, #212121 100%)`,
        p: 'md',
        gap: 'md',
      }}
      onCheckoutLoadingError={handleClose}
      onCheckoutSuccess={handleSuccess}
      checkoutId={checkoutId}
    />
  );
};

const ShortSessionCheckout = () => {
  const [searchParams] = useSearchParams();
  const checkoutId = searchParams.get('checkoutId');

  if (!checkoutId) return <LoadingOverlay visible />;

  return <Checkout />;
};

export { ShortSessionCheckout };
